export default "__VITE_ASSET__z1bXO5jn__"